import { type ReferenceLine } from '@meitu/saas-editor-core/es/plugins/apps/user-editor/reference-lines';

/** 获取模板详情类型 */
export enum FetchTemplateDetailDetailType {
    /** 模板 */
    TYPE_TEMPLATE = 'template',
    /** 作图记录 */
    TYPE_RECORD = 'record',
    /** ai ppt */
    TYPE_PPT = 'ppt',
    /** 复用团队模板 */
    TYPE_TEAM_TEMPLATE = 'team_template',
    /** 编辑团队模板 */
    TYPE_SOURCE_TEAM_TEMPLATE = 'source_team_template',
    /** 分享 */
    TYPE_SHARE = 'share',
    /** 品牌模板库 */
    TYPE_BRAND_TEMPLATE = 'brand_template',
}

export type ServerReferenceLineInfo = {
    lines: ReferenceLine[];
    show?: boolean;
    lock?: boolean;
};
